import { Modal, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FirstInvoiceModal = styled(Modal)`
  overflow: hidden;
`

export const InfoTextWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

export const LottieAnimationConfetti = styled.div`
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
`

export const FeaturesListItem = styled.li`
  display: flex;
  align-items: center;
  margin-top: ${Spacing.S16};
`

export const IconWrapper = styled.figure`
  display: flex;
  align-items: center;
  margin-right: ${Spacing.S8};
`

export const FirstInvoiceModalFooter = styled(Modal.Footer)`
  z-index: 1;
`
